import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/brokers')({
  component: BrokersLayout,
});

function BrokersLayout() {
  return <Outlet />;
}
